import WebApp from '@twa-dev/sdk';

const TG_LINK_REGEXP = /(https?:\/\/)?(www[.])?(telegram|t)\.me\/?/i;
const OLD_TG_LINK_REGEXP = /(https?:\/\/)?(www[.])?(telegram)\.me\/?/i;

export type OpenExternalOptions = Parameters<typeof WebApp.openLink>[1];

const noop = () => {};

export const openTelegramLink = (url: string) => (WebApp?.openTelegramLink ?? noop)(url);

export const openExternalLink = (url: string, options?: OpenExternalOptions) =>
  (WebApp?.openLink ?? noop)(url, options);

/**
 * Внутренний роут приложения (например, /listing), а не внешняя ссылка.
 * Протокол-относительные ссылки (//t.me/...) считаем внешними
 */
export const isInternalLink = (url: string) =>
  url.startsWith('/') && !url.startsWith('//');

export const isTGLink = (url: string) => TG_LINK_REGEXP.test(url);
export const isOldTGLink = (url: string) => OLD_TG_LINK_REGEXP.test(url);

const setShortTGDomain = (url: string): string => {
  // openTelegramLink method throws an Error when telegram.me domain is used
  if (isOldTGLink(url)) {
    return url.replace('telegram', 't');
  }
  return url;
};

export const prepareLink = (url: string): string => {
  const resolvedURL = setShortTGDomain(url);

  // hack to prevent crash in windows clients
  // resolvedURL = resolvedURL.replace('startattach', 'startapp');
  return resolvedURL;
};
